import "./ClientsOverview.css";
import 'react-phone-number-input/style.css';
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';
import React, { useEffect, useMemo, useState } from "react";
import DefultCompLogo from "../../images/icons/logo-default.svg";
import { Link } from 'react-router-dom';
import AES from "crypto-js/aes";
import { ClientCardSkeleton } from "./ClientCardSkeleton";

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'encryptionKey';

const ClientOverview = (props) => {
  useEffect(() => {
    if (props.updateClientList) {
      props.refetchClientProfiles();
    }
  }, [props.updateClientList, props.refetchClientProfiles]);

  const sortedData = useMemo(() => {
    const data = props.clientProfiles || [];
    switch (props.selectedSortOption) {
      case 'By name: A - Z':
        return data.slice().sort((a, b) => a.client_name.localeCompare(b.client_name));
      case 'By name: Z - A':
        return data.slice().sort((a, b) => b.client_name.localeCompare(a.client_name));
      case 'Date: old to new':
        return data.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      case 'Date: new to old':
        return data.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      default:
        return data;
    }
  }, [props.clientProfiles, props.selectedSortOption]);

  const filteredData = useMemo(() => {
    const searchTerm = (props.filter || '').trim().toLowerCase();
    return sortedData.filter((item) => {
      if (props.selectedStatus === "Active") return item.is_active && item.client_name?.toLowerCase().includes(searchTerm);
      if (props.selectedStatus === "Inactive") return !item.is_active && item.client_name?.toLowerCase().includes(searchTerm);
      return item.client_name?.toLowerCase().includes(searchTerm);
    });
  }, [sortedData, props.filter, props.selectedStatus]);

  return (
    <div className="client-ls-outer">
      <div className={`client-ls-inner ${!props.isLoading && filteredData.length === 0 ? 'client-ls-inner-no-data' : ''}`}>
        {props.isLoading === true ? (
          // Show skeleton loader during initial load
          <ClientCardSkeleton cards={25} />
        ) : (
          <>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <Link to={`/client/details/${encodeURIComponent(AES.encrypt(item._id, ENCRYPTION_KEY).toString().replace(/\//g, '%2F'))}`} key={item._id || index}>
                  <div className="ls-box">
                    <div className="ls-box-logo">
                      {item.company_logo !== "null" &&
                        item.company_logo !== null ? (
                        <img
                          src={`/uploads/clientCompyLogo/lowQuality/${item.company_logo.replace(/[^a-zA-Z0-9._-]/g, '')}`}
                          alt="Logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/uploads/clientCompyLogo/lowQuality/DefaultCompLogo.png';
                          }}
                        />
                      ) : (
                        <img
                          src={DefultCompLogo}
                          alt="Logo"
                        />
                      )}
                    </div>
                    <div className="client-name">{item.client_name}</div>
                  </div>
                </Link>
              ))
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                  <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                  <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                  <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No clients found</p>
                <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters or add a new client.</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ClientOverview;
